<app-page-wrapper [title]="'institutions' | i18n">
  <ng-container nav-action>
    <app-gloss-button [options]="addInstitutionButton"></app-gloss-button>
  </ng-container>

  <div class="table-wrapper">
    <app-ag-grid-table
      [options]="table?.options"
      [data]="table?.data()"
      [hasBottomBorder]="true"
      [hasTopBorder]="true"
    />
  </div>

  @if (table.institutionId()) {
    <div class="details-wrapper">
      <app-institution-details [institutionId]="table.institutionId()"></app-institution-details>
    </div>
  }
</app-page-wrapper>
